export const appAssetsConfig = {
    DEFAULT_COMPANY_LOGO : "/assets/images/company-logo.png",
    DEFAULT_PROFILE_IMAGE : "/assets/images/profile-image.png",
    DEFAULT_CAMERA_IMAGE : "/assets/images/camera.png"
}